module.exports = __webpack_public_path__ + "static/media/mk.d37cbce3.svg";